import React from "react";

import SinglePointRubricWithReordering from "./SinglePointRubricWithReordering";

const SinglePointRubricWithReorderingWrapper = props => {
  // TODO: revisit V2 component later
  // return !getIsScoreBasedRubricEnabled() ? (
  //   <SinglePointRubricWithReorderingV2 {...props} />
  // ) : (
  //   <SinglePointRubricWithReordering {...props} />
  // );

  return <SinglePointRubricWithReordering {...props} />;
};

export default SinglePointRubricWithReorderingWrapper;
